import type { FetchJSONWithTimeoutOptions } from '@noths/polaris-client-utils';
import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { endpoints } from './endpoints';
import type { Environment } from 'client-site-chrome-ui/environment';

const getUrl = (env: Environment) =>
  `${endpoints[env].favourites}/api/user-list/v1/lists/favourites/summary`;

const fetchOptions: FetchJSONWithTimeoutOptions = {
  method: 'GET',
  credentials: 'include',
  headers: {
    pragma: 'no-cache',
    'cache-control': 'no-cache',
  },
};

export const fetchFavourites = async (env: Environment) => {
  try {
    const response = await fetchJSONWithTimeout(getUrl(env), fetchOptions);

    if (response.ok) {
      return await response.json();
    }
  } catch (e) {
    console.error(`fetching favourites failed: ${(e as Error).message}`);
  }

  return null;
};
